import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client'

export type ShopifyClient = ApolloClient<NormalizedCacheObject>

/**
 * Gets Shopify ID from Shopify global ID.
 */
export const parseShopifyGlobalId = (shopifyGlobalId: string) => {
  try {
    return Number(shopifyGlobalId.split('?')[0].split('/').slice(-1)[0])
  } catch {
    return
  }
}
